<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";
import {
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogRoot,
  AlertDialogTitle,
} from "reka-ui";

const props = defineProps<{
  open: boolean;
}>();

const emit = defineEmits(["close"]);

const target = useTemplateRef<HTMLElement>("target");

onClickOutside(target, (event) => emit("close"));
</script>

<template>
  <AlertDialogRoot :open="open">
    <AlertDialogPortal>
      <AlertDialogOverlay
        class="bg-black/40 data-[state=open]:animate-overlayShow fixed inset-0 z-50"
      />
      <AlertDialogContent
        class="z-[100] text-[15px] data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[750px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white dark:bg-gray-700 p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none overflow-y-auto"
        ref="target"
      >
        <AlertDialogTitle
          class="text-gray-900 m-0 text-[17px] font-semibold flex items-center justify-between dark:text-white"
        >
          <slot
            name="title"
            class="px-6 py-4 text-xl font-bold text-gray-900 dark:text-white"
          ></slot>

          <Icon
            name="ri:close-fill"
            @click="() => emit('close')"
            class="w-8 h-8 cursor-pointer text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors"
          />
        </AlertDialogTitle>
        <AlertDialogDescription
          class="text-gray-900 dark:text-white mt-4 mb-5 text-[15px] leading-normal space-y-3"
        >
          <slot name="content" class="space-y-3"></slot>
        </AlertDialogDescription>
      </AlertDialogContent>
    </AlertDialogPortal>
  </AlertDialogRoot>
</template>
